import Component from './person-form-display-container';
export default Component;
